import React, { useEffect, useState } from "react";
import { getAllValideCongeByCode } from "../../Services/Pointeuse/CongeApi";

import CustomSyncLoader from "../Others/CustomSyncLoader";
import ErrorCustum from "../Others/ErrorCustum";
import ShowDecharge from "./ShowDecharge";

function DechargesConge() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setdata] = useState([]);
  const [fileUrl, setfileUrl] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  /**
   * It gets all the valid conge by code and filter the ones with decharge
   */
  const getData = () => {
    setLoading(true);
    getAllValideCongeByCode()
      .then((res) => {
        const withDecharge = res.data.filter((el) => {
          return !el.decharge == "" || !el.decharge == null;
        });
        setdata(withDecharge);
        console.log(withDecharge);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  };

  /**
   * It sets the fileUrl state variable to the value passed in.
   * @param value - The value of the input.
   */
  const handleSetFileUrl = (value) => {
    setfileUrl(value);
  };
  return (
    <div>
      <div className="page-header d-lg-flex d-block">
        <div className="page-leftheader">
          <h4 className="page-title">Décharge Congé</h4>
        </div>
        <div className="page-rightheader ml-md-auto">
          <div className=" btn-list">
            <button className="btn btn-light" data-toggle="tooltip" data-placement="top" title="E-mail">
              <i className="feather feather-mail" />
            </button>
            <button className="btn btn-light" data-placement="top" data-toggle="tooltip" title="Contact">
              <i className="feather feather-phone-call" />
            </button>
            <button className="btn btn-primary" data-placement="top" data-toggle="tooltip" title="Info">
              <i className="feather feather-info" />
            </button>
          </div>
        </div>
      </div>
      {/*End Page header*/}
      {/* Row*/}
      {loading && <CustomSyncLoader></CustomSyncLoader>}
      {!loading && error && <ErrorCustum></ErrorCustum>}
      {!loading && !error && data && (
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="row m-0 no-gutters">
                  <div className="col-lg-4">
                    <div className="border border-right-0 p-0 invoicelist" id="invoicelist">
                      <div className="card-body p-0">
                        <div className="tab-menu-heading sub-panel-heading p-0 border-0">
                          <div className="tabs-menu">
                            {/* Tabs */}
                            <ul className="nav panel-tabs">
                              {data.map((el, idx) => (
                                <li key={idx} className="active" onClick={() => handleSetFileUrl(el.decharge)}>
                                  <a className="d-flex" data-toggle="tab" href="#tab41" aria-expanded="true">
                                    {["png", "jpg", "jpeg"].some((element) =>
                                      el?.decharge.split(".").pop().includes(element)
                                    ) && (
                                      <img
                                        className="w-7 h-7 mr-4"
                                        src="https://coderthemes.com/highdmin/layouts/assets/images/file_icons/jpg.svg"
                                        alt="icon"
                                      />
                                    )}
                                    {el?.decharge.split(".").pop() === "pdf" && (
                                      <img
                                        className="w-7 h-7 mr-4"
                                        src="https://coderthemes.com/highdmin/layouts/assets/images/file_icons/pdf.svg"
                                        alt="icon"
                                      />
                                    )}
                                    <div className="mt-1">
                                      <h5 className="mb-1 font-weight-semibold mt-0">
                                        {el.motif} #{el.id}
                                      </h5>
                                      <p className="mb-0 text-muted">Date : {el.date}</p>
                                    </div>
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-8 p-md-0">
                    <div
                      className="panel-body tabs-menu-body p-6 invoice-print d-block invoicedetailspage"
                      id="invoicedetailspage"
                    >
                      <div className="tab-content">
                        <div className="tab-pane active text-center" id="tab01">
                          <div className="row my-7">
                            <div className="my-8 col-md-9 d-block mx-auto">
                              <img src="assets/images/files/file.png" alt="img" className="w-30 mb-4" />
                              <h4 className="font-weight-semibold">Décharge congé</h4>
                              <p className="text-muted">
                                Vous pouvez choisir un fichier à partir de la liste pour voir la décharge congé, vous
                                pouvez aussi choir l'un des actions ci-dessous.
                              </p>
                              <div className>
                                <button className="btn btn-light mt-1 mr-2">
                                  <i className="fe fe-eye" /> Voir
                                </button>
                                <button className="btn btn-light mt-1 mr-2">
                                  <i className="fe fe-download" /> Télécharger
                                </button>
                                {/* <button className="btn btn-light mt-1" onclick="javascript:window.print();">
                              <i className="fe fe-share" /> Send
                            </button> */}
                                <button className="btn btn-primary mt-1 mr-2">
                                  <i className="fe fe-printer" /> Imprimer
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="tab41">
                          <div className="card-body p-0">
                            <div className="invoice-header text-right d-block mb-5">
                              <h1 className="invoice-title font-weight-semibold text-uppercase mb-1">Décharge</h1>
                            </div>
                            {/* invoice-header */}
                            {fileUrl && <ShowDecharge fileUrl={fileUrl}></ShowDecharge>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DechargesConge;
